import React, { useState, createContext, useRef } from 'react';

export const StateContext = createContext();

const StateContainer = ({ children }) => {
  const [scriptContextualInformation, setScriptContextualInformation] =
    useState({ currentUrl: '-', datiContestoSito: [] });
  const [conversationStarted, setConversationStarted] = useState(false);
  const cardBodyRef = useRef(null);
  const [typeWriteText, setTypeWriteText] = useState('');
  const [typedTextScroll, setTypedTextScroll] = useState('');
  const [error, setError] = useState();
  const [leadCode, setLeadCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [currentLine, setCurrentLine] = useState(0);
  const [nascondiSidebar, setNascondiSidebar] = useState(false);
  const [listOfProjects, setListOfProjects] = useState([]);
  const [dominioDelSito, setDominioDelSito] = useState('');
  const [displayElements, setDisplayElements] = useState([]);
  const [nuovoProgetto, setNuovoProgetto] = useState([]);
  const [botMessageSent, setBotMessageSent] = useState(false);
  const [aggiornamentoDatiProgetto, setAggiornamentoDatiProgetto] =
    useState(null);
  const [dettagliProgetto, setDettagliProgetto] = useState([]);
  const [message, setMessage] = useState('');
  const [showFormRequestContacts, setShowFormRequestContacts] = useState(false);
  const [currentIndexTypeWrite, setCurrentIndexTypeWrite] = useState(0);
  const [isTypingMachine, setIsTypingMachine] = useState('');
  const [showFormContactFollowChat, setShowFormContactFollowChat] =
    useState(false);
  const [stopAgent, setStopAgent] = useState(false);
  const [showLoading, setShowLoading] = useState(false); // Stato per mostrare il caricamento

  const [currentChar, setCurrentChar] = useState(0);

  const [currentLineRef, setCurrentLineRef] = useState(0);

  return (
    <StateContext.Provider
      value={{
        scriptContextualInformation,
        setScriptContextualInformation,
        currentLineRef,
        setCurrentLineRef,
        showLoading,
        setShowLoading,
        stopAgent,
        setStopAgent,
        conversationStarted,
        setConversationStarted,
        cardBodyRef,
        currentLine,
        setCurrentLine,
        currentChar,
        setCurrentChar,
        typedTextScroll,
        setTypedTextScroll,
        message,
        setMessage,
        dettagliProgetto,
        setDettagliProgetto,
        aggiornamentoDatiProgetto,
        setAggiornamentoDatiProgetto,
        dominioDelSito,
        setDominioDelSito,
        nuovoProgetto,
        setNuovoProgetto,
        nascondiSidebar,
        setNascondiSidebar,
        loading,
        setLoading,
        error,
        setError,
        setListOfProjects,
        listOfProjects,
        showFormRequestContacts,
        setShowFormRequestContacts,
        leadCode,
        setLeadCode,
        typeWriteText,
        setTypeWriteText,
        currentIndexTypeWrite,
        setCurrentIndexTypeWrite,
        isTypingMachine,
        setIsTypingMachine,
        botMessageSent,
        setBotMessageSent,

        // Attivare e disattivare la form di contatto nel momento in cui l'utente scrive
        showFormContactFollowChat,
        setShowFormContactFollowChat,
      }}
    >
      {children}
    </StateContext.Provider>
  );
};

export default StateContainer;
